import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ServiceStock } from './service-stock.service';
import { gotxModalComponent } from './gotxModal/gotxModal.component';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private services: ServiceStock) {

  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = this.services.authService.currentUserValue;

    if (currentUser && this.services.http.sessionValid) {
      return true;
    }
    else {// If you are updating anything here then update that in Service Stock also by Mirsha
      this.services.dataStore.clearAll();
      this.services.http.sessionValid = false;
      this.services.http.oeLoggedIn = false;
      this.services.http.loggedIn = false;
      sessionStorage.clear();

      let params = {
        title: 'Alert',
        message: 'Session Expired',
        buttons: ['OK'],
        buttonAction: ['reload'],
        buttonClass: ['btn btn-primary'],
        type: "Alert"
      }

      const modalRef = this.services.openModal(gotxModalComponent, 'sm', params, "Gotx Popup");
      modalRef.result.then(() => {
        this.router.navigate(['/login']);
      }, () => {
        // this.closeResult =
        //   `Dismissed ${this.getDismissReason(reason)}`;
      });
      return false;
    }
  }
}
